<template>
  <div @click="handleImgClick" class="main">
    <vue-headful title="ITT流体技术" description="ITT流体技术" />
    <div class="header">
      <div><img class="spx-logo" src="../assets/spxflow-logo-2C.png" /></div>
      <!-- <div class="anh-logo-container"><img class="anh-logo"
             src="../assets/anhlogo.png"></div> -->
    </div>
    <div class="container">
      <div class="row" v-for="(d, idx) in !showMore ? normalChunk : chunkDownloads" :key="d.id">
        <div class="col-6" @click="toggleCheckStatus($event, idx, 0)">
          <div class="card mb-4 shadow-sm">
            <div class="card-body">
              <img v-if="d[0].type === 1 && email_enabled" class="card-check" id="card-check" :data-needinfo="d[0].need_info ? 1 : 0" :src="downloadCheckStatus[idx * 2] ? require('../assets/check.png') : require('../assets/uncheck.png')" />
              <div class="play-container">
                <img v-if="d[0].type === 2" class="card-cover" :src="d[0].cover" :data-needinfo="d[0].need_info ? 1 : 0" :data-file="d[0].download" :data-feedid="d[0].feed_id" @click.stop="play" />
                <img v-if="d[0].type === 1" class="card-cover" :src="d[0].cover" />
              </div>
              <div class="texts">
                <div class="text">{{ d[0].title }}</div>
                <div class="icon">
                  <a @click="download" :data-file="d[0].download" :data-needinfo="d[0].need_info ? 1 : 0" v-if="d[0].type === 1">
                    <img src="../assets/download.png" />
                  </a>
                  <a @click.stop="play" :data-file="d[0].download" :data-needinfo="d[0].need_info ? 1 : 0" :data-feedid="d[0].feed_id" v-if="d[0].type == 2">
                    <img src="../assets/play-button.png" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="d[1]" :class="{ 'col-6': true, even: true, odd: !d[1] }" @click="toggleCheckStatus($event, idx, 1)">
          <div class="card mb-4 shadow-sm">
            <div :class="{ 'card-body': true, 'card-body-odd': true }">
              <img v-if="d[1] && d[1].type === 1 && email_enabled" class="card-check" :data-needinfo="d[1].need_info ? 1 : 0" :src="downloadCheckStatus[idx * 2 + 1] ? require('../assets/check.png') : require('../assets/uncheck.png')" id="card-check" />
              <div class="play-container">
                <img v-if="d[1].type === 2" class="card-cover" :src="d[1].cover" :data-needinfo="d[1].need_info ? 1 : 0" :data-file="d[1].download" :data-feedid="d[1].feed_id" @click.stop="play" />
                <img v-if="d[1].type === 1" class="card-cover" :src="d[1].cover" />
              </div>
              <div class="texts">
                <div class="text">{{ d[1] ? d[1].title : "" }}</div>
                <div class="icon">
                  <a @click="download" :data-file="d[1].download" :data-needinfo="d[1].need_info ? 1 : 0" v-if="d[1].type === 1"><img src="../assets/download.png" /></a>
                  <a @click.stop="play" :data-file="d[1].download" :data-needinfo="d[1].need_info ? 1 : 0" :data-feedid="d[1].feed_id" v-if="d[1].type == 2"><img src="../assets/play-button.png" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <p
        id="more"
        class="text-right arrow"
        v-if="downloads.length > 6 && !showMore"
        @click="onHandleShowHidden"
      >
        点击查看更多 <img src="../assets/arrow.png" />
      </p> -->
    </div>
    <div class="email-button" @click="send" v-if="email_enabled">
      <img src="../assets/mail.png" />
    </div>
    <van-popup v-model="show">
      <div class="qr-container">
        <!-- <img src="@/assets/spx_qrcode2.jpeg" class="qrcode" /> -->
        <img src="@/assets/spx_qrcode.jpg" class="qrcode" />
        <p>请先关注公众号后进行操作</p>
      </div>
    </van-popup>
    <van-popup v-model="videoVisible" class="video-popup" @close="closeVideo">
      <video
        ref="videoPlayer"
        :src="videoUrl"
        controls
        autoplay
        playsinline
        webkit-playsinline
        class="video-player"
        @click.stop
      ></video>
    </van-popup>
  </div>
</template>

<script>
import { getCategory, getProfile, sendMail } from "@/api/request";
import chunk from "lodash/chunk";
import { Toast, Popup } from "vant";

export default {
  data: () => {
    return {
      downloads: [],
      showMore: true,
      email_enabled: true,
      chunkDownloads: [],
      downloadCheckStatus: [],
      normalChunk: [],
      foldChunk: [],
      show: false,
      user: {},
      videoVisible: false,
      videoUrl: "",
    };
  },
  components: {
    "van-popup": Popup,
  },
  methods: {
    async load() {
      // const user = await getProfile();
      // this.user = user.data;
      // if (this.user && this.user.wechat && this.user.wechat.subscribe == 0) {
      //   this.show = true;
      // }

      const res = await getCategory({ id: this.$route.params.id });
      this.downloads = res.data.category_downloads;
      this.chunkDownloads = chunk(this.downloads, 2);
      if (this.downloads.length > 6) {
        this.normalChunk = chunk(this.downloads.slice(0, 6), 2);
        console.log(this.normalChunk);
        this.foldChunk = chunk(this.downloads.slice(6), 2);
      } else {
        this.normalChunk = this.chunkDownloads;
      }
      this.downloadCheckStatus = this.downloads.map(() => {
        return false;
      });
    },
    async download(e) {
      const user = await getProfile();

      if (e.target.parentElement.attributes["data-needinfo"].value == 1 && user.data.reged == false) {
        Toast("请注册后查看");
        this.$router.push("/reg");
        return;
      }
      // download :href="d[0].download"
      location.href = e.target.parentElement.attributes["data-file"].value;
      console.log(e.target.parentElement.attributes["data-file"].value);
      e.stopPropagation();
    },
    async play(e) {
      const el = e.currentTarget;
      const needInfo = el.attributes["data-needinfo"] && el.attributes["data-needinfo"].value == 1;
      if (needInfo) {
        const user = await getProfile();
        if (user.data.reged == false) {
          Toast("请注册后查看");
          this.$router.push("/reg");
          return;
        }
      }
      const fileUrl = el.attributes["data-file"] ? el.attributes["data-file"].value : null;
      if (!fileUrl) return;
      this.videoUrl = fileUrl;
      this.videoVisible = true;
      e.stopPropagation();
    },
    closeVideo() {
      this.videoVisible = false;
      this.videoUrl = "";
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    },
    onHandleShowHidden() {
      this.showMore = !this.showMore;
    },
    async toggleCheckStatus(e, idx, offset) {
      const user = await getProfile();
      if (e.target.attributes["data-needinfo"].value == 1 && user.data.reged == false) {
        Toast("请注册后下载");
        this.$router.push("/reg");
        return;
      }

      if (e.target.id === "card-check") {
        let copy = [...this.downloadCheckStatus];
        copy[idx * 2 + offset] = !copy[idx * 2 + offset];
        this.downloadCheckStatus = copy;
      }
    },
    async send() {
      const ids = this.downloads
        .filter((el, index) => {
          return this.downloadCheckStatus[index];
        })
        .map((el) => el.id);

      const ids_needinfo = this.downloads
        .filter((el, index) => {
          return this.downloadCheckStatus[index] && el.need_info == 1;
        })
        .map((el) => el.id);

      const user = await getProfile();
      if (ids.length === 0) {
        Toast.fail("未选中内容");
        return;
      }
      if (user.data.status === 2 || user.data.reged) {
        Toast.loading({
          message: "邮件发送中...",
          forbidClick: true,
          duration: 0,
        });

        const res = await sendMail({ file_ids: ids });
        if (res.code === 200) {
          Toast.success("邮件发送成功");
        } else {
          Toast.fail("邮件发送失败");
        }
      } else {
        if (ids_needinfo.length > 0) {
          this.$router.push("/reg");
        } else {
          this.$router.push({
            name: "contact",
            params: { isEmail: true, ids },
          });
        }
        return;
      }
    },
    handleImgClick(e) {
      if (e.target.id === "message") {
        this.$router.push("/contact");
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

html,
body {
  width: 100vw;
}

.main {
  background: url("https://itt-ft.effective-wechat.com/spx1/img/bg.png") repeat-y;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-size: 100% auto;
  min-height: 100vh;
}

.main {
}

.header {
  display: flex;
  padding: 15px;
  padding-top: 30px;
  background: none;
  width: 100vw;
  box-sizing: border-box;
}

.header div {
  flex: 1;

  /* width: 100%; */
}

.spx-logo {
  width: 180px;
}

.anh-logo-container {
  text-align: right;
  margin-right: 10px;
  margin-top: 2px;
}

.anh-logo {
  width: 100px;
}

.row {
  width: 100%;
  /*margin: 5px;*/
  padding: 0 5px;
  box-sizing: border-box;
  display: flex;
}

.col-6 {
  flex: 1;
  margin: 10px;
  border-radius: 10px;
  background-color: #f6f5f5;
  box-shadow: 1px 1px 5px 1px #e5f0e5;
  max-width: calc((100vw - 50px) / 2);
}

.card {
  border-radius: 10px;
  background-color: #fff;
}

.card-body {
  border-radius: 10px;
  background-color: #f6f5f5;
  padding: 0;
  position: relative;
}

.card-body img {
  width: 100%;
  border-radius: 10px 10px 0 0;
}

.card-body video {
  width: 100%;
  border-radius: 10px 10px 0 0;
}

.play-container {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  video {
    width: 100%;
  }
}

.card-play {
  position: absolute;
  width: 40px !important;
  pointer-events: none;
}

.card-check {
  width: 18.5px !important;
  border-radius: 0 !important;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
}

.card-body .texts {
  display: flex;
  padding-bottom: 15px;
}

.card-body .text {
  flex: 1 0 80%;
  font-size: 14px;
  padding: 6px;
  box-sizing: border-box;
}

.card-body .icon {
  flex: 1 0 20%;
}

.card-body .icon img {
  width: 100%;
}

.arrow {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  padding-right: 15px;
}

.arrow img {
  width: 10px;
  margin-bottom: 3px;
  margin-left: 1px;
}

footer {
  padding: 15px;
}

footer img {
  width: 100%;
}

.more-block {
  display: none;
}

.no-bg {
  box-shadow: none;
  background: none;
}

.email-button {
  position: fixed;
  bottom: 36px;
  display: flex;
  img {
    margin-left: calc((100vw - 158px) / 2);
    width: 158px;
    height: 47px;
  }
}

.message {
  width: 150px;
  position: fixed;
  right: 0;
  margin-right: -60px;
  bottom: 234px;
}

.odd {
  box-shadow: none;
  background-color: transparent;
  .card-body-odd {
    background-color: transparent;
  }
}

.container {
  padding-bottom: 83px;
}
.qr-container {
  background-color: #fff;
  font-size: 12px;
  text-align: center;
  margin-bottom: 10px;
}
.qrcode {
  width: 200px;
}
.video-popup {
  width: 100vw;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-player {
  width: 100%;
  max-height: 100vh;
}
</style>
